export const getUrlLink = ({ project, type, entity }) => {
  // COPY: const {project } = useBOMDashboardContext();
  const base = `/projects/${project?.id}/equipments/main_tank#main-nav=MCS&mcs-tab=`;
  const typeUrl = () => {
    switch (type) {
      case "mrq":
        return "MRQ&mrq-id=";
      case "bid":
        return "Bid%20Evaluation&mrq-id=";
      case "po":
        return "PO%20Manager&po-id=";
      case "mrv":
        return "PO%20Manager&mrv-id=";
      case "srv":
        return "Drawing%20BOM&srv-id=";

      default:
        return "";
    }
  };
  return base + typeUrl() + entity?.id;
};

export const onVisitUrl = (link) => {
  const newTab = window.open(link, "_blank", "noopener,noreferrer");
  if (newTab) {
    newTab.focus();
  }
};
